import PeopleTab from '../../components/TabSpr.vue'
import InputGroupForm from '../../components/InputGroupForm.vue'
import http from '@/http-common'
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";
import PeopleEditPage from "@/views/people/PeopleEditPage.vue";
import ekpEditForm from "@/views/ekpForm/EkpEditForm.vue";

export default {
  name: "PeopleList",
  components: {FormSelectVue, PeopleTab, InputGroupForm, PeopleEditPage},
  props: {
    heightTab: {
      type: String,
      default: "65vh"
    },
    isCalledPeople: {
      type: Boolean,
      default: false,
    },
    columnsPeople: {
      type: Array,
      default: () => [
        {key: 'fio', label: 'ФИО'},
        {key: 'post', label: 'Должность', firstClass: 'width25'},
        {key: 'phoneTel', label: 'Номер телефона', firstClass: 'width10'},
        {key: 'federation.shortName', label: 'Федерация', firstClass: 'width25'},
        {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
      ],
    }
  },
  data() {
    return {
      modalLoadOpened: false,
      items: [],
      isBusy: false,
      fedList: [],
      ekpTypeList: [],
      captiontable: 'Ответственные',
      captionPeople: {
        name: 'Сотрудники',
        nameR: 'сотрудника'
      },
      urls: {
        save: '/people/save',
        delete: '/people/delete',
      },
      selectedItem: {
        id: null,
        fio: '',
        inn: '',
        post: '',
        phoneNumber: '',
        federationId: null
      },
      modalEditOpened: false,
      orgList: [],
      selectedOrg: [],
      stacked: {
        flg: false,
        size: 'md'
      }
    }
  },
  created() {
    this.loadFederations();
    this.loadOrgs();
    this.loadEkpTypes();
    this.loadItems();
  },
  computed: {
    ekpEditForm() {
      return ekpEditForm
    },
    classRowTab() {
      return {
        'col-md-10 offset-md-1 col-lg-10 offset-lg-1': !this.isCalledPeople,
        'col-xs-12 col-sm-12 col-md-12 col-lg-12': this.isCalledPeople,
      }
    }
  },
  methods: {
    rowSelected(items) {
      this.selected = items;
      //var rec = this.selectedItem;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      //this.selectedItem = rec;
      this.$emit('input', this.selectedItem)
    },
    loadItems() {
      var vm = this;
      this.isBusy = true;
      http.get('/people/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.message))
      .finally(() => vm.isBusy = false);
    },
    loadFederations() {
      var vm = this;
      http.get('/federation/list')
      .then((response) => {
        vm.fedList = response.data;
        // vm.fedList.forEach(function (x) {
        //     x.value = x.id;
        //     x.text = x.shortName;
        // })
      })
      .catch((error) => console.log(error.message));
    },
    loadOrgs() {
      var vm = this;
      http.get('/org/list')
      .then((response) => {
        vm.orgList = response.data;
        vm.orgList.forEach(function (x) {
          x.value = x.id;
          x.text = x.shortName;
        })
      })
      .catch((error) => console.log(error.message));
    },
    loadEkpTypes() {
      var vm = this;
      http.get('/workkind/EKP_TYPE/list')
      .then((response) => {
        vm.ekpTypeList = response.data;
        vm.ekpTypeList.forEach(function (x) {
          x.value = x.id;
          x.text = x.name;
        })
      })
      .catch((error) => console.log(error.message));
    },
    showEditDialog() {
      this.$refs.peopleEditRef.showEditDialog()
    },
    savePeople(people) {
      // this.checkForm();
      // if (this.validValue.form) {
      //   this.selectedItem.orgList = this.selectedOrg
      //   this.selectedItem.ekpTypes = this.selectedEkpTypes
      this.$refs.PeopleTabRef.save(people);
      // }
    },
    closeEditForm() {
      this.$refs.peopleEditRef.closeEditDialog()
    }
  }
}
